module.exports = __webpack_public_path__ + "img/finney.c4ced41d.png";